/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { UniversalCandidateHitSchema } from './universalCandidateHitSchema';

export interface UniversalCandidateGroupSchema {
  items: UniversalCandidateHitSchema[];
  has_more: boolean;
}
